import {
  USER_FETCH_REQUEST,
  USER_FETCH_REQUEST_SUCCESS,
  USER_FETCH_REQUEST_FAILURE,
  USER_ADD_REQUEST,
  USER_ADD_REQUEST_SUCCESS,
  USER_ADD_REQUEST_FAILURE,
  USER_UPDATE_REQUEST,
  USER_UPDATE_REQUEST_SUCCESS,
  USER_UPDATE_REQUEST_FAILURE,
  USER_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
  pagination: {
    current: 0,
    pageSize: 0,
    total: 0,
    totalPage: 0,
  },
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const usersReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case USER_FETCH_REQUEST:
    case USER_ADD_REQUEST:
    case USER_UPDATE_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case USER_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
        pagination: {
          current: action.data.currentPage,
          pageSize: action.data.pageSize,
          total: action.data.totalRecord,
          totalPage: action.data.totalPage,
          showSizeChanger: true,
        },
      });

    case USER_ADD_REQUEST_SUCCESS:
    case USER_UPDATE_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case USER_FETCH_REQUEST_FAILURE:
    case USER_ADD_REQUEST_FAILURE:
    case USER_UPDATE_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case USER_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
        pagination: {
          current: 0,
          pageSize: 0,
          total: 0,
          totalPage: 0,
        },
      });

    default:
      return state;
  }
};

export default usersReducer;
